export default "__VITE_ASSET__DdZkvV2Q__"